<template xmlns:v-slot="http://www.w3.org/1999/html">
  <div class="kt-portlet kt-portlet--height-fluid mt-3">
    <div
      class="kt-portlet__head kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm flex-wrap"
    >
      <div class="kt-portlet__head-label mb-2">
        <span class="kt-portlet__head-icon">
          <i class="fal fa-phone-square-alt" />
        </span>
        <h3 class="kt-portlet__head-title">Phone Number Manager</h3>
      </div>
      <div class="kt-portlet__head-toolbar">
        <div class="kt-portlet__head-group">
          <v-btn
            color="primaryMain"
            dark
            class="text-white mb-2 mr-2"
            style="color: white !important"
            @click="$store.commit('phoneNumbers/setReleasePhoneNumberDialogState', true)"
          >
            Release My Numbers
          </v-btn>

          <v-btn
            color="primaryMain"
            dark
            class="primaryMainText--text mb-2 mr-2"
            v-on="on"
            @click="massDelete"
          >
            <i class="fal fa-trash mr-2" />
            Release Multiple Number
          </v-btn>
          <v-dialog
            v-model="newNumberForm"
            max-width="800px"
            transition="dialog-bottom-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="primaryMainText--text mb-2" v-on="on">
                <i class="fal fa-plus mr-2" />
                New Number
              </v-btn>
            </template>
            <v-card>
              <v-toolbar dark color="secondary">
                <v-card-title>
                  <i class="fal fa-phone-plus mr-1" />
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-spacer></v-spacer>
                <button
                  type="button"
                  class="btn btn-light btn-elevate-hover btn-circle btn-icon btn-sm"
                  @click="close"
                >
                  <i class="fal fa-times" />
                </button>
              </v-toolbar>
              <v-card-text>
                <v-container class="kt-form">
                  <!-- Number's Info -->
                  <h4 class="mt-5">
                    <span>
                      <i class="fal fa-info-circle" />
                    </span>
                    Number's Info
                  </h4>
                  <v-row>
                    <v-col>
                      <v-autocomplete
                        v-model="editedItem.provider"
                        label="Provider"
                        :items="phoneNumberProviders"
                        item-text="name"
                        item-value="id"
                        name="provider"
                        data-vv-name="provider"
                        :loading="loaders.providers"
                        v-validate="'required'"
                        id="provider"
                      >
                      </v-autocomplete>
                      <span class="kt-font-danger validate-error">{{
                        errors.first('provider')
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-autocomplete
                        v-model="editedItem.country"
                        label="Country"
                        :items="countries"
                        item-text="name"
                        :loading="loaders.countries"
                        item-value="id"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-autocomplete
                        v-model="editedItem.state"
                        :items="states"
                        item-text="name"
                        item-value="id"
                        @change="setAreaCode"
                        v-validate="'required'"
                        :disabled="checkStatesLoader"
                        name="state"
                        :menu-props="{ closeOnClick: true }"
                        label="State"
                        :return-object="false"
                        prepend-icon="fal fa-route-interstate"
                      ></v-autocomplete>
                      <span class="kt-font-danger validate-error">{{
                        errors.first("state")
                      }}</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedItem.area_code"
                        @blur="getNumbers"
                        v-validate="'required'"
                        label="Area Code"
                        :disabled="isFetchingNumbers"
                        name="areaCode"
                        append-icon="fal fa-search"
                      ></v-text-field>
                      <span class="kt-font-danger validate-error">{{
                        errors.first("areaCode")
                      }}</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <vue-select
                        v-model="editedItem.number"
                        :options="numberList"
                        append-to-body
                        :menu-props="{ closeOnClick: true }"
                        label="friendly_name"
                        :loading="isNumberFetched"
                        v-validate="'required'"
                        name="number"
                        :reduce="(item) => item.friendly_name"
                      >
                        <template #option="item">
                          <p>
                            {{ item.friendly_name }}
                          </p>
                          <p>
                            <v-icon
                              v-if="item.capabilities.voice_ready"
                              primary
                              class="mr-2"
                              >fas fa-phone-alt</v-icon
                            >
                            <v-icon
                              v-if="item.capabilities.sms_ready"
                              secondary
                              x-small
                              class="mr-2"
                            >
                              fas fa-sms
                            </v-icon>
                            <v-icon v-if="item.capabilities.mms_ready" x-small>
                              fas fa-photo-video
                            </v-icon>
                          </p>
                          <!-- <em>{{ author.firstName }} {{ author.lastName }}</em> -->
                        </template>
                        <template #header>
                          <div>Select a Phone Number</div>
                        </template>
                      </vue-select>
                      <span class="kt-font-danger validate-error">{{
                        errors.first("number")
                      }}</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-autocomplete
                        v-model="editedItem.dealer"
                        v-validate="'required'"
                        name="dealers"
                        :items="dealers"
                        item-text="name"
                        item-value="id"
                        :menu-props="{ closeOnClick: true }"
                        :return-object="false"
                        label="Select a Company"
                      ></v-autocomplete>
                      <span class="kt-font-danger validate-error">{{
                        errors.first("dealers")
                      }}</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-autocomplete
                        v-model="editedItem.secret_shopper"
                        :items="secretShopperList"
                        item-text="name"
                        item-value="id"
                        :return-object="false"
                        name="secretShopper"
                        v-validate="'required'"
                        :menu-props="{ closeOnClick: true }"
                        label="Select a Secret Shopper"
                      />
                      <span class="kt-font-danger validate-error">{{
                        errors.first("secretShopper")
                      }}</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        v-model="editedItem.audio"
                        :items="voiceMails"
                        item-text="name"
                        item-value="id"
                        v-validate="'required'"
                        :return-object="false"
                        name="voiceMail"
                        :menu-props="{ closeOnClick: true }"
                        label="Select a Voicemail Recording"
                      />
                      <span class="kt-font-danger validate-error">{{
                        errors.first("voiceMail")
                      }}</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        v-model="editedItem.category"
                        :items="categoryList"
                        :menu-props="{ closeOnClick: true }"
                        label="Category"
                        item-text="name"
                        item-value="value"
                        name="category"
                        :return-object="false"
                        v-validate="'required'"
                      />
                      <span class="kt-font-danger validate-error">{{
                        errors.first("category")
                      }}</span>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn color="blue-grey darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text :loading="isLoading" @click="save"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </div>
    <div class="kt-portlet__body">
      <v-data-table
        :headers="headers"
        :items="numbers.data"
        :search="pagination.search"
        :sort-by="pagination.sortBy"
        :sort-desc="sortDesc"
        class="elevation-1"
        :items-per-page="pagination.per_page"
        :server-items-length="pagination.total"
        @update:page="changePage"
        :loading="isFetchingRecords"
        v-model="selectedNumbers"
        show-select
        @update:sort-by="sortByUpdate"
        @update:sort-desc="sortDescUpdate"
      >
        <template v-slot:item.created_at="{ item }">
          <span>{{ item.created_at | displayDateTime }}</span>
        </template>
        <template v-slot:top>
          <div class="px-3">
            <div class="row no-gutters pt-3">
              <div class="col-xl-4">
                <v-select
                  class="mt-0 pt-0"
                  :loading="isFetchingRecords"
                  :disabled="isFetchingRecords"
                  @change="fetchData"
                  v-model="filters"
                  multiple
                  prepend-inner-icon="fas fa-filter"
                  :items="['Active', 'Inactive']"
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple @click="toggleAllFilter">
                      <v-list-item-content>
                        <v-list-item-title>All</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
                <v-menu
                  ref="rangeMenu"
                  v-model="dateRange.rangeMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      class="pt-0"
                      v-model="dateRangeText"
                      :value="dateRangeText"
                      label="Filter Date Range"
                      prepend-icon="fal fa-calendar"
                      v-on="on"
                      clearable
                      @click:clear="clearDateRangeSelection"
                      clear-icon="fal fa-times-circle"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateRange.dates"
                    range
                    no-title
                    color="blue"
                    value="mm-dd-YYYY"
                  >
                    <v-spacer />
                    <v-btn text color="info" @click="cancelRangeSelection">Cancel</v-btn>
                    <v-btn text color="info" @click="confirmRangeSelection">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
              <v-spacer />
              <div class="col-xl-4">
                <v-text-field
                  class="mt-0 pt-0"
                  v-model.trim="pagination.search"
                  @keydown="fetchSearch"
                  append-icon="fal fa-search"
                  label="Search"
                  single-line
                  hide-details
                />
              </div>
            </div>
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <div v-if="item.deleted_at === null">
            <v-btn text @click="editItem(item)" color="grey darken-3" small>
              <v-icon small>fal fa-edit</v-icon>
            </v-btn>
            <v-btn text @click="deleteItem(item)" color="red darken-3" small>
              <v-icon small>fal fa-trash</v-icon>
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="openSyncDialog(item)"
              v-if="item.phone_number_provider.name === 'twilio'"
            >
              <v-icon small>fal fa-sync</v-icon>
            </v-btn>
          </div>
          <div v-else>INACTIVE RECORD</div>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="resetTable">Reset</v-btn>
        </template>
      </v-data-table>
    </div>
    <confirm-dialog
      :show-dialog="showConfirmDeleteDialog"
      :confirm-action="proceedToDeletion"
      :close-dialog="closeConfirmDeleteDialog"
      :loading="isFetchingRecords"
    >
      Are you sure you want to proceed?
    </confirm-dialog>
    <release-phone-number-dialog></release-phone-number-dialog>

    <v-dialog width="500px" v-model="showSyncDialog" persistent>
      <v-card>
        <v-toolbar dark coor="blue lighten-4">
          <v-toolbar-title>
            <v-icon small class="mr-2">fal fa-info-circle</v-icon>
            Phone Number Data Sync
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showSyncDialog = false">
            <i class="fal fa-times" />
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col>
              <v-alert type="warning">
                Data sync is only available on Twilio.
                Using this feature will delete all the existing call logs
                or SMS logs and replace them with the new ones.
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                  color="warning"
                  style="color:white !important;"
                  :loading="syncLoader.call"
                  @click="syncCallLogs(selectedItem)"
              >
                <v-icon small class="mr-2" >fas fa-phone-alt</v-icon>
                Sync Call Logs
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-btn
                  color="warning"
                  style="color:white !important;"
                  @click="syncSmsLogs(selectedItem)"
                  :loading="syncLoader.sms"
              >
                <v-icon small class="mr-2">fas fa-sms</v-icon>
                Sync SMS Logs
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  isEmpty as _isEmpty,
  forEach as _forEach,
  find as _find,
  filter as _filter,
  debounce as _debounce,
  cloneDeep as _cloneDeep,
  isArray as _isArray,
} from "lodash-es";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog";
import ReleasePhoneNumberDialog from "./PhoneNumber/ReleasePhoneNumberDialog.vue";

const dict = {
  custom: {
    areaCode: {
      required: "The area code is required",
    },
    secretShopper: {
      required: "The Secret Shopper field is required.",
    },
    voiceMail: {
      required: "The voicemail field is required.",
    },
  },
};

export default {
  name: "NumberManagement",
  components: { ConfirmDialog, ReleasePhoneNumberDialog },
  data: () => ({
    options: {},
    isFetchingRecords: false,
    isLoading: false,
    isNumberFetched: false,
    isFetchingNumbers: false,
    on: "",
    newNumberForm: false,
    selectedNumbers: [],
    numberList: [],
    filters: "",
    categoryList: [
      {
        name: "For Competitor",
        value: 0,
      },
      {
        name: "For Dealer",
        value: 1,
      },
    ],
    headers: [
      {
        text: "Number",
        align: "left",
        sortable: false,
        value: "value",
      },
      {
        text: "Date Created",
        value: "created_at",
        sortable: true,
      },
      {
        text: "Secret Shopper",
        value: "user.name",
        sortable: true,
      },
      {
        text: "Company",
        value: "dealer.name",
        sortable: true,
      },
      {
        text: "Category",
        value: "category_value",
        sortable: true,
      },
      {
        text: "Actions",
        value: "action",
        align: "center",
        width: 200,
        sortable: false,
      },
    ],
    editedIndex: -1,
    editedItem: {
      provider: null,
      country: null,
      state: null,
      area_code: null,
      number: null,
      secret_shopper: null,
      dealer: null,
      audio: null,
      category: null,
    },
    defaultItem: {
      country: 1,
      state: "",
      area_code: "",
      number: "",
      secret_shopper: "",
      dealer: "",
      audio: "",
      category: "",
    },
    pagination: {
      total: 1,
      per_page: 5,
      current_page: 1,
      search: "",
      sortBy: "created_at",
    },
    sortDesc: true,
    showConfirmDeleteDialog: false,
    selectedItem: {},
    countries: [],
    loaders: {
      countries: false,
      providers: false,
    },
    dateRange: {
      rangeMenu: false,
      dateRange: "",
      dates: [],
    },
    phoneNumberProviders: [],
    syncLoader: {
      sms: false,
      call: false,
    },
    showSyncDialog: false,
  }),

  computed: {
    dateRangeText() {
      if (!this.dateRange.dates) {
        return "";
      }
      return this.dateRange.dates.join(" ~ ");
    },
    checkStatesLoader() {
      return _isEmpty(this.states);
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Number" : "Edit Number";
    },
    states() {
      return _filter(this.$store.state.states.states, {
        country_id: this.editedItem.country,
      });
    },
    cities() {
      return this.$store.state.cities.cities;
    },
    voiceMails() {
      return this.$store.state.voiceMails.voiceMails;
    },
    secretShopperList() {
      return this.$store.state.secretShoppers.secretShoppers;
    },
    dealers() {
      return this.$store.state.dealers.dealers;
    },
    numbers() {
      return this.$store.state.phoneNumbers.phoneNumbers;
    },
  },
  watch: {
    newNumberForm(val) {
      // eslint-disable-next-line no-unused-expressions
      val || this.close();
    },
    numbers(val) {
      this.pagination.total = val.total;
      this.pagination.current_page = val.current_page;
    },
  },

  created() {
    this.toggleAllFilter();
    this.fetchData();
    this.$store.dispatch("secretShoppers/getSecretShoppers");
    this.$store.dispatch("voiceMails/getVoiceMails");
  },

  mounted() {
    this.$validator.localize("en", dict);
    this.init();
    this.fetchPhoneProviders();
  },

  methods: {
    sortByUpdate(value) {
      this.pagination.sortBy = value;
      this.pagination.current_page = 1;
      this.fetchData();
    },
    sortDescUpdate(desc) {
      this.pagination.sortDesc = desc;
      this.currentPage = 1;
      this.fetchData();
    },
    fetchTelnyxNumbers(form) {
      this.axios
        .get("v3/telnyx/available-phone-numbers", {
          params: form,
        })
        .then(({ data }) => {
          this.numberList = data.phone_numbers;
          if (this.numberList.length !== 0) {
            this.$notify(
              "success",
              "Successfully fetched numbers from Telnyx. You can now pick."
            );
          } else {
            this.$notify("error", "No number found matching the selected area number(s)");
          }
          this.isNumberFetched = false;
          this.isFetchingNumbers = false;
        });
    },
    fetchTwilioNumbers(form) {
      this.axios
        .get("v3/twilio/available-phone-numbers", {
          params: form,
        })
        .then(({ data }) => {
          this.numberList = data.phone_numbers;
          if (this.numberList.length !== 0) {
            this.$notify(
              "success",
              "Successfully fetched numbers from twilio. You can now pick."
            );
          } else {
            this.$notify("error", "No number found matching the selected area number(s)");
          }
        })
        .finally(() => {
          this.isNumberFetched = false;
          this.isFetchingRecords = false;
          this.isFetchingNumbers = false;
        });
    },
    fetchPhoneProviders() {
      this.axios.get("v3/phone-numbers/providers").then(({ data }) => {
        this.phoneNumberProviders = data.providers;
      });
    },
    cancelRangeSelection() {
      this.dateRange.dates = [];
      this.$refs.rangeMenu.save(null);
      this.dateRange.rangeMenu = false;
      this.pagination.current_page = 1;
      this.fetchData();
    },
    confirmRangeSelection() {
      this.$refs.rangeMenu.save(this.dateRange.dates);
      this.rangeMenu = false;
      this.pagination.current_page = 1;
      this.fetchData();
    },
    clearDateRangeSelection() {
      this.dateRange.rangeMenu = false;
      this.dateRange.dates = [];
      this.$refs.rangeMenu.save(null);
    },
    fetchSearch: _debounce(function () {
      this.fetchData();
    }, 1000),
    getCountries() {
      this.loaders.countries = true;
      this.axios
        .get("v3/countries")
        .then(({ data }) => {
          this.countries = data;
          this.loaders.countries = false;
        })
        .catch(() => {
          this.loaders.countries = false;
        });
    },
    closeConfirmDeleteDialog() {
      this.isFetchingRecords = false;
      this.showConfirmDeleteDialog = false;
      this.selectedItem = {};
    },
    toggleAllFilter() {
      this.filters = ["Active", "Inactive"];
    },
    init() {
      this.$store.dispatch("secretShoppers/getSecretShoppers");
      this.$store.dispatch("voiceMails/getVoiceMails");
      this.getCountries();
    },
    changePage(page) {
      this.pagination.current_page = page;
      this.fetchData();
    },
    massDelete() {
      /* eslint-disable */
      let isSelectedNumbersEmpty = _isEmpty(this.selectedNumbers);
      if (!isSelectedNumbersEmpty) {
        let ids = [];
        _forEach(this.selectedNumbers, (val) => {
          ids.push(val.id);
        });
        this.$store
          .dispatch("phoneNumbers/deletePhoneNumber", ids)
          .then(() => {
            this.$notify("success", "Phone Numbers removed.");
            this.$store.commit("phoneNumbers/massDeletePhoneNumber", ids);
          })
          .catch((error) => console.log(error));
      } else {
        this.$notify("error", "There are no selected numbers!");
      }
    },
    fetchData() {
      this.pagination.sortBy =
        this.pagination.sortBy !== undefined ? this.pagination.sortBy : "created_at";
      if (_isArray(this.pagination.sortDesc)) {
        this.pagination.sortDesc = this.pagination.sortDesc[0];
      }

      const pageSettings = _cloneDeep(this.pagination);
      pageSettings.between_at = this.dateRange.dates;
      this.isFetchingRecords = true;

      this.$store
        .dispatch("phoneNumbers/fetchPhoneNumbers", {
          pagination: pageSettings,
          filters: this.filters,
        })
        .then(({ data }) => {
          this.pagination.total = data.total;
          this.pagination.current_page = data.current_page;
          this.pagination.per_page = Number(data.per_page);
          this.$store.commit("phoneNumbers/setPhoneNumbers", data);
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$notify(
              "error",
              "Please select one or more filter(s) for proper displaying of data."
            );
            this.$store.commit("phoneNumbers/setPhoneNumbers", []);
          }
        })
        .finally(() => (this.isFetchingRecords = false));
    },
    setAreaCode(val) {
      const state = _find(this.states, { id: val });
      this.editedItem.area_code = state.area_codes;
    },
    purchaseNumberOnTwilio(payload) {
      this.$store
        .dispatch("phoneNumbers/addPhoneNumber", payload)
        .then(({ data }) => {
          this.fetchData();
          this.$notify("success", "Added Phone Number");
        })
        .finally(() => {
          this.isFetchingRecords = false;
          this.close();
        });
    },
    store(payload) {
      this.isFetchingRecords = true;
      this.isLoading = true;

      this.purchaseNumberOnTwilio(payload);
    },
    getNumbers() {
      const country = _find(this.countries, {
        id: this.editedItem.country,
      });

      const form = {
        area_codes: this.editedItem.area_code.split(","),
        country_iso_code: country.iso_code_alpha_2,
      };

      this.$validator.validate("areaCode").then((valid) => {
        if (valid) {
          this.isNumberFetched = true;
          this.isFetchingNumbers = true;
          if (this.editedItem.provider === 2) {
            this.fetchTwilioNumbers(form);
          } else {
            this.fetchTelnyxNumbers(form);
          }
        }

        return false;
      });
    },

    editItem(item) {
      this.editedIndex = this.numbers.data.indexOf(item);


      Object.assign(this.editedItem, {
         provider: item.phone_number_provider_id === null
          ? 2 : item.phone_number_provider_id,
        country: _isEmpty(item.country_id) ? 1 : item.state.country_id,
        state: item.state_id !== null ? item.state.id : null,
        area_code: item.area_codes,
        number: item.value,
        secret_shopper: item.user.id,
        dealer: item.dealer.id,
        audio: item.voice_mail.id,
        category: item.is_dealer,
      });

      this.$nextTick(() => {
        this.newNumberForm = true;
      });
    },

    update(payload) {
      const index = this.editedIndex;
      const { id } = this.numbers.data[index];
      payload.id = id;
      this.isLoading = true;
      this.isFetchingRecords = true;
      this.$store
        .dispatch("phoneNumbers/updatePhoneNumber", payload)
        .then(({ data }) => {
          this.$notify("success", "Phone number updated");
          this.$store.commit("phoneNumbers/editPhoneNumber", data);
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.isFetchingRecords = false;
          this.close();
        });
    },

    proceedToDeletion() {
      if (!_isEmpty(this.selectedItem)) {
        this.isFetchingRecords = true;
        this.$store
          .dispatch("phoneNumbers/deletePhoneNumber", this.selectedItem.id)
          .then(() => {
            this.$notify("success", "Phone number released");
            this.fetchData();
            this.closeConfirmDeleteDialog();
          })
          .catch((error) => console.log(error));
      } else {
        let ids = [];
        _forEach(this.selectedNumbers, (val) => {
          ids.push(val.id);
        });
        this.isFetchingRecords = true;
        this.$store
          .dispatch("phoneNumbers/deletePhoneNumber", ids)
          .then(() => {
            this.$notify("success", "Phone Numbers removed.");
            this.$store.commit("phoneNumbers/massDeletePhoneNumber", ids);
            this.closeConfirmDeleteDialog();
          })
          .catch((error) => console.log(error));
      }
    },

    deleteItem(item = null) {
      this.selectedItem = item;
      this.showConfirmDeleteDialog = true;
    },

    close() {
      this.isLoading = false;
      this.newNumberForm = false;
      this.isFetchingNumbers = false;
      this.isFetchingRecords = false;
      this.isNumberFetched = false;
      this.numberList = [];
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$validator.reset();
      }, 300);
    },

    save() { 
      this.$validator.reset();

      this.$validator.localize("en", dict);
      this.$validator.validate("*")
        .then((isValid) => {
          if (isValid) {
            // eslint-disable-next-line no-unused-expressions
            if (this.editedIndex === -1) {
              this.store(this.editedItem);
            } else {
              this.update(this.editedItem);
            }
          }
        });
    },

    resetTable() {
      this.pagination.search = "";
      this.toggleAllFilter();
      this.fetchData();
    },
    syncSmsLogs(item) {
      this.syncLoader.sms = true;
      this.axios.post('v3/phone-numbers/sync/twilio/sms', { phone_number_id: item.id })
        .then(() => {
          this.syncLoader.sms = false;
          this.$notify('success', 'SMS logs synced successfully');

          this.showSyncDialog = false;
        })
        .catch(() => {
          this.syncLoader.sms = false;
          this.$notify('error', 'Failed to sync SMS logs');
        });
    },
    syncCallLogs(item) {
      this.syncLoader.call = true;
      this.axios.post('v3/phone-numbers/sync/twilio/call', { phone_number_id: item.id })
      .then(() => {
        this.syncLoader.call = false;
        this.$notify('success', 'Call logs synced successfully');

        this.showSyncDialog = false;
      })
      .catch(() => {
        this.syncLoader.call = false;
        this.$notify('error', 'Failed to sync Call logs');
      });
    },
    openSyncDialog(item) {
      this.selectedItem = item;
      this.showSyncDialog = true;
    },
  },
};
</script>
<style lang="stylus" scoped>
.v-icon.v-icon {
    font-size: 16px;
}
</style>
